import Transformer from './Transformer';

export default class LocationsTransformer extends Transformer {
  public transform(location: any) {
    location.longitude = parseFloat(location.longitude);
    location.latitude = parseFloat(location.latitude);
    location.type = location.type.id ?
      location.type.id :
      location.type;
    location.category = location.category[0].id ?
      location.category.map((v) => v.id) :
      location.category;

    if (location.course) {
      location.course = location.course.id ?
        location.course.id :
        location.course;
    } else {
      delete location.course;
    }

    if (location.shop) {
      if (location.shop[0]) {
        location.shop = location.shop.map((v) => v.id);
      } else {
        location.shop = location.shop.id ?
          location.shop.id :
          location.shop;
      }
    } else {
      delete location.shop;
    }

    return location;
  }
}
